export const name = 'The Fitted Furniture Company';
export const description =
  'Handmade kitchens, fitted wardrobes and bespoke fitted furniture handmade in Norwich, Norfolk';

// contact details
export const mobile = '07811 131 620';
export const mobileHref = 'tel:+447811131620';
export const phone = '01508 558 384';
export const phoneHref = 'tel:+441508558384';
export const email = 'will@theffc.co.uk';
export const emailHref = 'mailto:will@theffc.co.uk';

// social networks
export const tumblrUserId = 'thefittedfurnitureco';

export const twitterUserId = 'ffc_the';
export const twitterPage = `https://twitter.com/${twitterUserId}/`;

export const facebookId = '100067592951341';
export const facebookPage = `https://www.facebook.com/profile.php?id=${facebookId}`;

export const instagramId = 'fittedfurniturecompany';
export const instagramPage = `https://www.instagram.com/${instagramId}/`;
export const instagramLinkText = 'Follow us on Instagram';

export const googlePlaceId = 'ChIJ02KpLWjl2UcRFXEMUKcaNVA';

export const apiBaseUrl = 'https://sirkettle.herokuapp.com';

export const maxWidthPx = 1920;

export const maxMobileWidthPx = 850;



// WEBPACK FOOTER //
// ./src/constants/site.js